import { render, staticRenderFns } from "./importWechatArticle.vue?vue&type=template&id=cda43f88"
import script from "./importWechatArticle.vue?vue&type=script&lang=js"
export * from "./importWechatArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports